var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSideArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.226799 0.000435978C0.253624 0.00199978 0.280073 0.0134976 0.304802 0.0343463L4.86293 3.72378C4.90336 3.75584 4.93805 3.81146 4.96249 3.88341C4.98693 3.95537 5 4.04034 5 4.12733C5 4.21431 4.98693 4.29928 4.96249 4.37123C4.93805 4.44318 4.90336 4.4988 4.86293 4.53086L0.304802 8.22031C0.278302 8.24168 0.249956 8.25241 0.221383 8.25188C0.19281 8.25134 0.164568 8.23957 0.138272 8.21721C0.111975 8.19485 0.0881381 8.16235 0.0681217 8.12157C0.0481052 8.08079 0.0323014 8.03254 0.0216124 7.97955C2.51131e-05 7.87252 0.000582508 7.75273 0.0231618 7.64652C0.0457411 7.54032 0.0884928 7.4564 0.142012 7.41323L4.20159 4.13071L0.142012 0.841413C0.0934113 0.805596 0.0528168 0.736209 0.0275591 0.645779C0.00230139 0.55535 -0.00595466 0.449831 0.00428211 0.348295C0.0145189 0.246759 0.0425736 0.155894 0.0833799 0.0920999C0.124186 0.028306 0.175055 -0.00420336 0.226799 0.000435978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSideArrow);
export default __webpack_public_path__ + "static/media/RightSideArrow.661ff6a5a7c323a84d42bf786ce6db5a.svg";
export { ForwardRef as ReactComponent };